var _path, _path2, _path3, _rect, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 29,
    viewBox: "0 0 130 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47921 18.9059V8.40262L5.84245 6.95842L6.36761 7.221L14.9015 2.36324H14.9015L23.4354 7.221L23.9606 6.95842L26.3238 8.40262V18.9059L29.803 16.8709V12.9322L27.3085 11.5536V7.74617L24.2888 6.10503V5.31728L14.9015 0H14.9015L5.51422 5.31728V6.10503L2.49453 7.74617V11.5536L0 12.9322V16.8709L3.47921 18.9059Z",
    fill: "#FF754C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31738 9.45285L14.9016 4.00427V4.00441L24.4858 9.45295V20.4158L20.6127 22.6477V26.7834L18.8403 27.8993V23.5667L18.0526 24.0919V28.2932L16.4771 29.2779V24.9453L15.6893 25.5361V29.5405L14.9016 30V29.9999L14.1139 29.5404V25.536L13.3261 24.9452V29.2778L11.7506 28.2931V24.0918L10.9629 23.5666V27.8992L9.19047 26.7833V22.6476L5.31738 20.4156V9.45285ZM13.2802 14.0156L10.4377 12.4729L7.59515 14.0156V17.1009L10.4377 18.6436L13.2802 17.1009V14.0156ZM19.3654 12.4729L22.208 14.0156V17.1009L19.3654 18.6436L16.5229 17.1009V14.0156L19.3654 12.4729ZM16.3797 18.6763L14.9016 17.8558L13.4235 18.6763V20.3175L14.9016 21.138L16.3797 20.3175V18.6763Z",
    fill: "#6C5DD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5032 13.5232C10.1044 13.5232 9.78113 13.8465 9.78113 14.2453V14.8361H9.19036C8.79156 14.8361 8.46826 15.1594 8.46826 15.5582C8.46826 15.957 8.79156 16.2803 9.19036 16.2803H9.78113V16.8711C9.78113 17.2699 10.1044 17.5932 10.5032 17.5932C10.902 17.5932 11.2253 17.2699 11.2253 16.8711V16.2803H11.8162C12.215 16.2803 12.5383 15.957 12.5383 15.5582C12.5383 15.1594 12.215 14.8361 11.8162 14.8361H11.2253V14.2453C11.2253 13.8465 10.902 13.5232 10.5032 13.5232Z",
    fill: "#FF754C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.8206,
    y: 18.9061,
    width: 1.18162,
    height: 1.70678,
    transform: "rotate(90 15.8206 18.9061)",
    fill: "#FF754C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7089 14.9016H19.9561V14.0482L19.2997 13.6543L18.7089 14.0482V14.9016ZM18.6433 16.214V14.9668H17.7899L17.396 15.6232L17.7899 16.214H18.6433ZM19.9561 16.2797H18.7089V17.1331L19.2997 17.527L19.9561 17.1331V16.2797ZM20.0218 16.214V14.9668H20.8752L21.2691 15.6232L20.8752 16.214H20.0218Z",
    fill: "#FF754C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.223 22.48V11.64L40.403 8.5H51.003L54.183 11.64V22.48H49.963V18.48H41.443V22.5L37.223 22.48ZM41.443 11.64V15.4H49.963V11.64H41.443ZM61.4472 19.36H73.4472L70.3272 22.5H57.2272V8.52L61.4472 6.08V19.36ZM70.7663 8.5H89.5063L86.4063 11.64H82.2463V22.48H78.0263V11.64H73.8663L70.7663 8.5ZM91.2111 8.5H107.931L104.831 11.64H95.4311V14.1H105.891L103.051 16.94H95.4311V19.36H107.431L104.311 22.5H91.2111V8.5ZM109.962 8.5H124.582L127.762 12.82L125.342 16.06L127.762 18.48V22.48H123.542V19.06L122.262 17.82H114.182V22.5H109.962V8.5ZM114.182 14.64H122.282L123.422 13.08L122.322 11.64H114.182V14.64Z",
    fill: "#1B1D21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.fdb534fab61ffe8d19305559c5c7712a.svg";
export { ForwardRef as ReactComponent };